import { FC, ReactNode } from "react";

import blueCornerCircle from "../../../assets/backgrounds/backgroundCornerCircle/blueCornerCircle.svg";
import pinkCornerCircle from "../../../assets/backgrounds/backgroundCornerCircle/pinkCornerCircle.svg";
import greenCornerCircle from "../../../assets/backgrounds/backgroundCornerCircle/greenCornerCircle.svg";
import yellowCornerCircle from "../../../assets/backgrounds/backgroundCornerCircle/yellowCornerCircle.svg";

interface CornerCirclesBackgroundProps {
    children: ReactNode
}

const CornerCirclesBackground: FC<CornerCirclesBackgroundProps> = ({ children }) => {

    return (
        <div className="corner_circles_background_wrapper" style={{ width: "100vw", height: "100vh" }}>
            <div className="blured_filter_wrapper">
                <div className="blured_filter"></div>
                <img className="top_left_corner" src={blueCornerCircle} alt="" />
                <img className="top_right_corner" src={pinkCornerCircle} alt="" />
                <img className="bottom_right_corner" src={greenCornerCircle} alt="" />
                <img className="bottom_left_corner" src={yellowCornerCircle} alt="" />
            </div>

            <div className="content_above_the_blured_filter">
                    {children}
            </div>
        </div>
    )
}

export default CornerCirclesBackground;